import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { DateTimeRange } from '@/core/DateTimeRange.molecule';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import type { Moment } from 'moment';
import type { RangeField } from '@/core/DateTimeRange.molecule';
import type { Timezone } from '@/datetime/timezone.service';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface DateTimeRangeIF extends ValidatingFormComponent<RangeField<moment.Moment>> {
  component: 'DateTimeRangeFormComponent';
  hideTimezone?: boolean;
  timezone: Timezone;
  onStartTimeChange?: (value: moment.Moment) => void;
  onEndTimeChange?: (value: moment.Moment) => void;
  disabled?: boolean;
  value: RangeField<moment.Moment>;
}

export const DateTimeRangeFormComponent = (props: DateTimeRangeIF) => {
  const {
    label,
    name,
    testId = 'dateTimeRange',
    extraClassNames,
    value,
    hideTimezone,
    timezone,
    customErrorText,
    extendValidation,
    validation,
    onStartTimeChange,
    onEndTimeChange,
    disabled,
  } = props;

  const formState = useForm().getState();
  const showError = _.has(formState.errors, name) && _.has(formState.dirtyFields, name);

  const defaultValidation = (value: RangeField<moment.Moment>) =>
    !value || !value.start || !value.end || value.start.isAfter(value.end);
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  return (
    <FormFieldWrapper
      testId={testId}
      label={label}
      extraClassNames={extraClassNames}
      showError={showError}
      customErrorText={customErrorText}>
      <Field<RangeField<Moment>> name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const { onChange } = getFormFieldProps(formState, input, meta, props);

          return (
            <DateTimeRange
              startTime={value.start}
              endTime={value.end}
              onChange={onChange}
              onStartTimeChange={onStartTimeChange}
              onEndTimeChange={onEndTimeChange}
              hideTimezone={Boolean(hideTimezone)}
              timezone={timezone}
              disabled={disabled}
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
